import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-initiative-milestone-sub-tasks',
  templateUrl: './initiative-milestone-sub-tasks.component.html',
  styleUrls: ['./initiative-milestone-sub-tasks.component.scss'],
})
export class InitiativeMilestoneSubTasksComponent implements OnInit {
  @Input() initiative_data: any;
  @Input() milestone_data: any;
  @Input() parent_task_data: any;
  @Input() filters_data: any;

  user_details: any;

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public dateFormate: DatePipe,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.user_details = this.storageService.get('user_details');
    this.getTasks();
    this.getTaskNames();
    this.getTaggingUsers();
    this.getCommunicationTypes();
    this.getStatusList();
    this.getAppointmentStatusList();
  }

  tagging_users_list: any = [];
  getTaggingUsers() {
    this.commonService.getData('/taguserslist/').subscribe(
      (res: any) => {
        this.tagging_users_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  task_names_list: any = [];
  getTaskNames() {
    const user_data = this.storageService.get('user_details');
    this.commonService
      .getData(
        '/taskName?user_type=' + user_data.role.group.name + '&no_page=true/',
      )
      .subscribe(
        (res: any) => {
          this.task_names_list = res;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  communication_type_list: any = [];
  getCommunicationTypes() {
    this.commonService.getData('/communicationType/?no_page=true').subscribe(
      (res: any) => {
        this.communication_type_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  status_list: any = [];
  getStatusList() {
    this.commonService.getData('/status/?no_page=true').subscribe(
      (res: any) => {
        this.status_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  appointment_status_list: any = [];
  getAppointmentStatusList() {
    // this.commonService.getData("/appointmentStatus/?no_page=true").subscribe(
    this.commonService.getData('/conversionStatus/').subscribe(
      (res: any) => {
        this.appointment_status_list = res['results'];
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  tasks_data: any = [];
  getTasks() {
    this.show_sub_tasks = null;

    this.tasks_data = [];
    let route =
      '/task?parent_activity=' +
      this.parent_task_data.id +
      '&sub_task=true&no_page=true&status=' +
      this.filters_data.status +
      '&start_date=' +
      moment(this.filters_data.start_date).format('YYYY-MM-DD') +
      '&end_date=' +
      moment(this.filters_data.end_date).format('YYYY-MM-DD');
    this.commonService.getData(route).subscribe(
      (res: any) => {
        this.tasks_data = res;
        for (let index = 0; index < this.tasks_data.length; index++) {
          this.commonService
            .getData(
              '/taskcomments?task=' +
                this.tasks_data[index].id +
                '&ordering=id&no_page=true',
            )
            .subscribe(
              (comments: any) => {
                this.tasks_data[index].comments = [];
                for (let cIndex = 0; cIndex < comments.length; cIndex++) {
                  this.tasks_data[index].comments.push(comments[cIndex]);
                }
              },
              (err) => {
                this.commonService.showToast('error', err.error);
              },
            );
        }
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  @ViewChild('activitiesOperationsModal')
  activitiesOperationsModal: TemplateRef<any>;
  private activitiesOperationsModalRef: MatDialogRef<TemplateRef<any>>;

  selected_activity_data: any = {
    name: '',
    description: '',
    due_date: '',
    actual_date: '',
    communication_type: '',
    status: '',
  };
  selected_activity_data_errors: any = {
    name: false,
    description: false,
    due_date: false,
    actual_date: false,
    communication_type: false,
    status: false,
  };
  activity_operation_type: any = 'Add';
  activity_operation_index: any = null;
  comment_data: any = {
    comment_date: '',
    description: '',
  };
  comment_data_errors: any = {
    comment_date: false,
    description: false,
  };

  openActivityOperationModal(data, type, index) {
    this.selected_activity_data = data;
    if (
      this.selected_activity_data.due_date != null &&
      this.selected_activity_data.due_date != ''
    ) {
      // this.selected_activity_data.due_date = this.dateFormate.transform(
      //   this.selected_activity_data.due_date,
      //   'MM/dd/yyyy',
      // );
      this.selected_activity_data.due_date = new Date(
        this.selected_activity_data.due_date,
      );
    } else {
      // this.selected_activity_data.due_date = this.dateFormate.transform(
      //   new Date(),
      //   'MM/dd/yyyy',
      // );
      this.selected_activity_data.due_date = new Date();
    }

    if (
      this.selected_activity_data.actual_date != null &&
      this.selected_activity_data.actual_date != ''
    ) {
      // this.selected_activity_data.actual_date = this.dateFormate.transform(
      //   this.selected_activity_data.actual_date,
      //   'MM/dd/yyyy',
      // );
      this.selected_activity_data.actual_date = new Date(
        this.selected_activity_data.actual_date,
      );
    } else {
      // this.selected_activity_data.actual_date = this.dateFormate.transform(new Date(), "MM/dd/yyyy");
      // this.selected_activity_data.actual_date = new Date();
      this.selected_activity_data.actual_date = null;
    }

    this.activity_operation_type = type;
    this.activity_operation_index = index;
    this.activitiesOperationsModalRef = this.dialog.open(
      this.activitiesOperationsModal,
      { disableClose: true },
    );
    this.activitiesOperationsModalRef.afterClosed().subscribe((result) => {
      this.closeActivityOperationModal();
    });
  }

  closeActivityOperationModal() {
    this.resetModalData();
    this.activitiesOperationsModalRef.close();
  }

  resetModalData() {
    this.selected_activity_data = {
      name: '',
      description: '',
      due_date: '',
      actual_date: '',
      communication_type: '',
      status: '',
    };
    this.selected_activity_data_errors = {
      name: false,
      description: false,
      due_date: false,
      actual_date: false,
      communication_type: false,
      status: false,
    };
    this.activity_operation_type = 'Add';
    this.activity_operation_index = null;
    this.comment_data = {
      comment_date: '',
      description: '',
    };
    this.comment_data_errors = {
      comment_date: false,
      description: false,
    };
  }

  saveTask() {
    if (
      this.selected_activity_data.name != '' &&
      this.selected_activity_data.name != null
    ) {
      this.selected_activity_data_errors.name = false;
    } else {
      this.selected_activity_data_errors.name = true;
    }

    // if (this.selected_activity_data.description != "" && this.selected_activity_data.description != null) {
    //   this.selected_activity_data_errors.description = false;
    // } else {
    //   this.selected_activity_data_errors.description = true;
    // }

    if (
      this.selected_activity_data.due_date != '' &&
      this.selected_activity_data.due_date != null
    ) {
      this.selected_activity_data_errors.due_date = false;
    } else {
      this.selected_activity_data_errors.due_date = true;
    }

    // if (this.selected_activity_data.actual_date != "" && this.selected_activity_data.actual_date != null) {
    //   this.selected_activity_data_errors.actual_date = false;
    // } else {
    //   this.selected_activity_data_errors.actual_date = true;
    // }

    if (
      this.selected_activity_data.communication_type != '' &&
      this.selected_activity_data.communication_type != null
    ) {
      this.selected_activity_data_errors.communication_type = false;
    } else {
      this.selected_activity_data_errors.communication_type = true;
    }

    if (
      this.selected_activity_data.status != '' &&
      this.selected_activity_data.status != null
    ) {
      this.selected_activity_data_errors.status = false;
    } else {
      this.selected_activity_data_errors.status = true;
    }

    if (
      (this.comment_data.comment_date != undefined &&
        this.comment_data.comment_date != '') ||
      this.comment_data.description != ''
    ) {
      if (
        this.comment_data.comment_date == undefined ||
        this.comment_data.comment_date == '' ||
        this.comment_data.comment_date == null
      ) {
        this.comment_data_errors.comment_date = true;
      } else {
        this.comment_data_errors.comment_date = false;
      }

      // if (this.comment_data.description == "" || this.comment_data.description == null) {
      //   this.comment_data_errors.description = true;
      // } else {
      //   this.comment_data_errors.description = false;
      // }

      if (
        this.comment_data_errors.comment_date == false &&
        // this.comment_data_errors.description == false &&
        this.activity_operation_type == 'Edit'
      ) {
        this.saveComment();
      }
    } else {
      this.comment_data_errors.comment_date = false;
      this.comment_data_errors.description = false;
    }

    if (
      this.selected_activity_data_errors.name == false &&
      // this.selected_activity_data_errors.description == false &&
      this.selected_activity_data_errors.due_date == false &&
      // this.selected_activity_data_errors.actual_date == false &&
      this.selected_activity_data_errors.communication_type == false &&
      this.selected_activity_data_errors.status == false &&
      this.comment_data_errors.comment_date == false &&
      this.comment_data_errors.description == false
    ) {
      let payload: any = {
        name: this.selected_activity_data.name,
        description: this.selected_activity_data.description,
        due_date: moment(this.selected_activity_data.due_date).format(),
        actual_date: moment(this.selected_activity_data.actual_date).format(),
        communication_type: this.selected_activity_data.communication_type,
        status: this.selected_activity_data.status,
        parent_activity: this.parent_task_data.id,
      };
      if (
        this.selected_activity_data.actual_date != undefined &&
        this.selected_activity_data.actual_date != '' &&
        this.selected_activity_data.actual_date != null
      ) {
        payload.actual_date = moment(
          this.selected_activity_data.actual_date,
        ).format();
      } else {
        this.selected_activity_data.actual_date = null;
        payload.actual_date = null;
      }

      if (this.activity_operation_type == 'Add') {
        this.commonService.postData('/task/', payload).subscribe(
          (res: any) => {
            let data: any = res;
            data.comments = [];
            // this.tasks_data.push(data);
            // this.tasks_data.push(this.selected_activity_data);
            this.getTasks();
            this.closeActivityOperationModal();
            this.commonService.showToast('success', 'Task Added Successfully.');
          },
          (err) => {
            this.commonService.showToast('error', err.error);
          },
        );
      } else if (this.activity_operation_type == 'Edit') {
        payload.id = this.selected_activity_data.id;
        this.commonService
          .updateData('/task/' + payload.id + '/', payload)
          .subscribe(
            (res: any) => {
              let data: any = res;
              this.commonService
                .getData(
                  '/taskcomments?task=' + data.id + '&ordering=id&no_page=true',
                )
                .subscribe(
                  (comments: any) => {
                    data.comments = [];
                    for (let cIndex = 0; cIndex < comments.length; cIndex++) {
                      data.comments.push(comments[cIndex]);
                    }
                  },
                  (err) => {
                    this.commonService.showToast('error', err.error);
                  },
                );
              // this.tasks_data.splice(this.activity_operation_index, 1, data);
              // this.tasks_data.splice(this.activity_operation_index, 1, this.selected_activity_data);
              this.getTasks();
              this.closeActivityOperationModal();
              this.commonService.showToast(
                'success',
                'Task Updated Successfully.',
              );
            },
            (err) => {
              this.commonService.showToast('error', err.error);
            },
          );
      }
    }
  }

  @ViewChild('activitiesDeleteModal') activitiesDeleteModal: TemplateRef<any>;
  private activitiesDeleteModalRef: MatDialogRef<TemplateRef<any>>;
  removeActivity(data, index) {
    this.selected_activity_data = data;
    this.activity_operation_index = index;
    this.activitiesDeleteModalRef = this.dialog.open(
      this.activitiesDeleteModal,
      { disableClose: true },
    );
    this.activitiesDeleteModalRef.afterClosed().subscribe((result) => {
      this.closeDeleteActivityModal();
    });
  }

  closeDeleteActivityModal() {
    this.resetModalData();
    this.activitiesDeleteModalRef.close();
  }

  deleteActivity() {
    this.commonService
      .delete('/task/destroy?ids=' + this.selected_activity_data.id)
      .subscribe(
        (res: any) => {
          // this.tasks_data.splice(this.activity_operation_index, 1);
          this.getTasks();
          this.closeDeleteActivityModal();
          this.commonService.showToast('success', 'Task Deleted Successfully.');
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  @ViewChild('commentsModal') commentsModal: TemplateRef<any>;
  private commentsModalRef: MatDialogRef<TemplateRef<any>>;
  openCommentsModal(advisor, data) {
    this.selected_activity_data = data;
    this.commentsModalRef = this.dialog.open(this.commentsModal, {
      disableClose: true,
    });
    this.commentsModalRef.afterClosed().subscribe((result) => {
      this.closeCommentsModal();
    });
  }

  closeCommentsModal() {
    this.comment_data = {
      comment_date: '',
      description: '',
    };
    this.comment_data_errors = {
      comment_date: false,
      description: false,
    };
    this.commentsModalRef.close();
  }

  saveComment() {
    // if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
    //   this.comment_data_errors.comment_date = false;
    // } else {
    //   this.comment_data_errors.comment_date = true;
    // }

    // if (this.comment_data.description != "" && this.comment_data.description != null) {
    //   this.comment_data_errors.description = false;
    // } else {
    //   this.comment_data_errors.description = true;
    // }

    if (
      this.comment_data_errors.comment_date == false
      // &&
      // this.comment_data_errors.description == false
    ) {
      const payload = {
        comment_date: moment(this.comment_data.comment_date).format(),
        description: this.comment_data.description,
        milestone_task: this.milestone_data.id,
      };
      this.commonService.postData('/taskcomments/', payload).subscribe(
        (res: any) => {
          this.selected_activity_data.comments.push(res);
          // this.closeCommentsModal();
          this.commonService.showToast(
            'success',
            'Comment Added Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }
  }

  deleteComment(data, comment, index) {
    this.commonService
      .delete('/taskcomments/destroy/?ids=' + comment.id)
      .subscribe(
        (res: any) => {
          data.splice(index, 1);
          this.comment_data = {
            comment_date: '',
            description: '',
          };
          this.comment_data_errors = {
            comment_date: false,
            description: false,
          };
          // this.closeCommentsModal();
          this.commonService.showToast(
            'success',
            'Comment Deleted Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  status_data: any = {
    appointment_status: '',
    appointment_reason: '',
  };
  status_data_errors: any = {
    appointment_status: false,
    appointment_reason: false,
  };
  @ViewChild('statusModal') statusModal: TemplateRef<any>;
  private statusModalRef: MatDialogRef<TemplateRef<any>>;
  openStatusModal(data) {
    this.status_data = JSON.parse(JSON.stringify(data));
    this.statusModalRef = this.dialog.open(this.statusModal, {
      disableClose: true,
    });
    this.statusModalRef.afterClosed().subscribe((result) => {
      this.closeStatusModal();
    });
  }

  closeStatusModal() {
    this.status_data = {
      appointment_status: '',
      appointment_reason: '',
    };
    this.status_data_errors = {
      appointment_status: false,
      appointment_reason: false,
    };
    this.statusModalRef.close();
  }

  saveStatus() {
    if (
      this.status_data.appointment_status != '' &&
      this.status_data.appointment_status != null
    ) {
      this.status_data_errors.appointment_status = false;
    } else {
      this.status_data_errors.appointment_status = false;
    }

    if (
      this.status_data.appointment_reason != '' &&
      this.status_data.appointment_reason != null
    ) {
      this.status_data_errors.appointment_reason = false;
    } else {
      this.status_data_errors.appointment_reason = false;
    }

    if (
      this.status_data_errors.appointment_status == false &&
      this.status_data_errors.appointment_reason == false
    ) {
      const payload = {
        appointment_status: this.status_data.appointment_status,
        appointment_reason: this.status_data.appointment_reason,
        id: this.status_data.id,
      };
      // this.commonService.postData("/changestatus/", payload).subscribe(
      //   (res: any) => {
      //     this.closeStatusModal();
      //     this.commonService.showToast("success", "Advisor Appointment Status Changed Successfully.");
      //   },
      //   (err) => {
      //     this.commonService.showToast("error", err.error);
      //   }
      // )
      this.commonService.patch('/advisor/' + payload.id, payload).subscribe(
        (res: any) => {
          this.closeStatusModal();
          this.commonService.showToast(
            'success',
            'Advisor Appointment Status Changed Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }
  }

  show_sub_tasks: number = null;
  toggleSubTasksView(value) {
    if (this.show_sub_tasks == value) {
      this.show_sub_tasks = null;
    } else {
      this.show_sub_tasks = value;
    }
  }
}
